<template>
  <div v-locale>
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useThemeStore } from "@/stores/theme";
import { loadTypographyConfig } from "@/services/UiStyleService";
import { useLocalization } from "@/composables/useLocalization";
import { adminApi } from "@/api/adminApi";
import { onMounted } from "vue";

const authStore = useAuthStore();
const themeStore = useThemeStore();
const { detectLocale } = useLocalization();

onMounted(async () => {
  // Session is already restored in main.ts before mount — no need to call
  // tryRestoreSession() again here.  We only need to init the theme.
  themeStore.init();
  if (authStore.isAuthenticated) {
    // Sync theme from DB; falls back to localStorage if endpoint not deployed
    themeStore.syncFromServer();
    // Load admin-configured typography CSS variables
    try { await loadTypographyConfig(); } catch { /* use defaults */ }
    // Detect and apply user/company preferred locale
    try {
      const res = await adminApi.getUserLanguage();
      const userLang = res.data?.data?.preferredLanguage;
      const companyLang = res.data?.data?.companyDefault;
      await detectLocale(userLang, companyLang);
    } catch { /* use default locale */ }
  }
});
</script>
